import React from 'react';
import { ShieldCheck, Lock, Rocket, Headphones, CheckCircle2, MessagesSquare } from 'lucide-react';
import { TRUST_PILLARS, COMMITMENTS } from '../mock';

const iconMap = { ShieldCheck, Lock, Rocket, HeadphonesIcon: Headphones, MessagesSquare };

const Credibility = () => (
  <section className="py-20 bg-white border-y border-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 items-start">
        <div>
          <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#FF5B24]">
            <CheckCircle2 size={13} /> Por que a CoreDesk
          </div>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0a0e27] leading-tight">
            Uma plataforma feita para <span className="text-[#FF5B24]">crescer com você</span>
          </h2>
          <p className="mt-4 text-slate-600">
            Somos uma nova geração de plataforma de atendimento: com IA de verdade, integrações nativas e time humano no Brasil. Sem letras miúdas, sem taxas escondidas.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-4">
            {COMMITMENTS.map((c) => (
              <div key={c.k} className="border-l-2 border-[#FF5B24] pl-3">
                <div className="text-2xl font-black text-[#0a0e27]">{c.k}</div>
                <div className="text-xs text-slate-500 mt-1 leading-snug">{c.v}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {TRUST_PILLARS.map((p) => {
            const Icon = iconMap[p.icon] || ShieldCheck;
            return (
              <div key={p.title} className="group bg-white rounded-2xl border border-slate-100 p-6 hover:border-[#FF5B24]/40 hover:shadow-xl transition-all">
                <div className="w-11 h-11 rounded-xl bg-[#FFF1EA] flex items-center justify-center group-hover:bg-[#FF5B24] transition-colors">
                  <Icon size={20} className="text-[#FF5B24] group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-4 font-extrabold text-lg text-[#0a0e27]">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default Credibility;
